(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonial-motion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonial-portrait-gallery')) {
    class TestimonialPortraitGallery extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.cards = Array.from(this.querySelectorAll('.vtpg__person[data-index]'));
        this.dots = Array.from(this.querySelectorAll('[data-progress-dot]'));
        if (!this.cards.length) return;
        this.current = Math.min(Number(this.dataset.initialIndex) || 0, this.cards.length - 1);
        this.interval = Number(this.dataset.interval) || 7000;
        this.autoplay = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.stage = this.querySelector('.vtpg__stage');
        this.visible = false;
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.move(-1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.move(1, true));
        this.cards.forEach((card, index) => card.querySelector('[data-select-person]')?.addEventListener('click', () => this.goTo(index, true)));
        this.stage?.addEventListener('touchstart', event => { this.touchStartX = event.changedTouches[0].clientX; this.stop(); }, { passive: true });
        this.stage?.addEventListener('touchend', event => { const distance = event.changedTouches[0].clientX - this.touchStartX; if (Math.abs(distance) > 42) this.move(distance < 0 ? 1 : -1, true); this.start(); }, { passive: true });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.visible ? this.start() : this.stop(); }, { threshold: .3 });
        this.observer.observe(this);
        this.render(false);
      }
      disconnectedCallback() { this.stop(); this.observer?.disconnect(); }
      move(direction, userInitiated = false) { this.goTo(this.current + direction, userInitiated); }
      goTo(index, userInitiated = false) { this.current = (index + this.cards.length) % this.cards.length; this.render(true); if (userInitiated) { this.stop(); this.start(); } }
      render(animate) {
        const count = this.cards.length;
        this.cards.forEach((card, index) => {
          let slot = index - this.current;
          if (slot > count / 2) slot -= count;
          if (slot < -count / 2) slot += count;
          const distance = Math.abs(slot);
          const previousSlot = Number(card.dataset.slot);
          const wrapsAround = Number.isFinite(previousSlot) && Math.abs(previousSlot - slot) > 6;
          if (wrapsAround) card.classList.add('is-no-transition');
          card.dataset.slot = slot;
          card.dataset.distance = Math.min(distance, 5);
          card.classList.toggle('is-active', slot === 0);
          card.classList.toggle('is-outside', distance > 6);
          card.setAttribute('aria-hidden', slot === 0 ? 'false' : 'true');
          card.querySelector('[data-select-person]')?.setAttribute('tabindex', distance <= 6 ? '0' : '-1');
          if (wrapsAround) requestAnimationFrame(() => requestAnimationFrame(() => card.classList.remove('is-no-transition')));
          if (!animate) { card.classList.add('is-no-transition'); requestAnimationFrame(() => requestAnimationFrame(() => card.classList.remove('is-no-transition'))); }
        });
        this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === this.current));
      }
      start() { if (!this.autoplay || !this.visible || this.timer || this.cards.length < 2) return; this.timer = window.setInterval(() => this.move(1), this.interval); }
      stop() { window.clearInterval(this.timer); this.timer = null; }
    }
    customElements.define('testimonial-portrait-gallery', TestimonialPortraitGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
